import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize } from "react-localize-redux";
import { Translate } from 'react-localize-redux';
import { amlCandidatesActions } from '../../../store/amlCandidatesStore';
import { validateInput } from '../../../store/storeFunctions';
class AmlCandidatesFilter extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const radix = 10;
        const value = parseInt(event.target.value, radix);
        this.props.applyLimit(this.props.section, isNaN(value) ? 0 : value);
    }

    render() {
        if (this.props.hideRatioFilter)
            return null;

        return (
            <div className="aml-filter-input">
                <Translate id="Report.Aml.Subjects.CandidatesFilter" />
                <input type="text" className="input" value={this.props.sections[this.props.section].newLimit} onChange={this.handleChange} onInput={(e) => validateInput(e)}/>
                %
            </div>
        )
    }
}

export default withLocalize(connect(
    state => state.amlCandidates,
    dispatch => bindActionCreators(amlCandidatesActions, dispatch)
)(AmlCandidatesFilter));